import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function ProblemSection() {
  const problems = ['El relleno se vuelve aguado y pierde el crujido en pocas horas.', 'El pistacho sabe demasiado artificial.', 'El chocolate se quiebra de forma desastrosa al cortarlo.'];
  return <section className="py-24 px-6 bg-dark" data-id="element-141">
      <div className="max-w-4xl mx-auto" data-id="element-142">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-143">
          <h2 className="font-serif text-3xl md:text-4xl text-cream mb-6" data-id="element-144">
            La cruda realidad de intentar replicarlo...
          </h2>
          <p className="font-sans text-lg text-cream-muted max-w-2xl mx-auto" data-id="element-145">
            La mayoría de las personas que intentan recrear esta tendencia
            fracasan en tres puntos críticos:
          </p>
        </motion.div>

        <div className="grid gap-6 md:grid-cols-3 mb-16" data-id="element-146">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} viewport={{
          once: true
        }} className="bg-dark-card border border-white/5 p-8 rounded-lg text-center relative overflow-hidden group hover:border-red-900/30 transition-colors" data-id="element-147">
              <div className="absolute top-0 left-0 w-full h-1 bg-red-900/20 group-hover:bg-red-800/40 transition-colors" data-id="element-148"></div>
              <XCircle className="w-12 h-12 text-red-500/80 mx-auto mb-6" strokeWidth={1.5} data-id="element-149" />
              <p className="font-sans text-cream-muted leading-relaxed" data-id="element-150">
                {problem}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} viewport={{
        once: true
      }} className="text-center font-sans text-lg text-cream-muted space-y-6 max-w-3xl mx-auto" data-id="element-151">
          <p data-id="element-152">
            No hay nada más frustrante que gastar dinero en ingredientes
            costosos para que el resultado final parezca un postre casero común
            en lugar de la joya de lujo que viste en la pantalla.
          </p>
          <p className="text-cream font-medium" data-id="element-153">
            Quieres impresionar, quieres ese regalo perfecto para una fecha
            especial, pero no quieres tirar tu dinero en experimentos que no
            funcionan.
          </p>
        </motion.div>
      </div>
    </section>;
}